export interface JsonValidationResult {
  valid: boolean;
  message?: string;
  normalized?: string | null;
  value?: unknown;
}

export const BUSINESS_EVENT_JSON_SNIPPETS = {
  condition: '{"all":[{"field":"jobStatus","op":"eq","value":"DRIVER_JOB_COMPLETED"}]}',
  whatsappRecipient: '[{"type":"PAYLOAD_PATH","value":"driver.phoneNumber","labelPath":"driver.name"}]',
  waybillAttachment: '[{"type":"SHIPMENT_WAYBILL","required":true,"shipmentIdPath":"shipmentId","deliveryIdPath":"deliveryId"}]',
  samplePayload: `{
  "jobStatus": "DRIVER_JOB_COMPLETED",
  "shipmentId": 1001,
  "deliveryId": 501,
  "shipmentNumber": "SHP-1001",
  "deliveryNumber": "DEL-501",
  "origin": "Riyadh",
  "destination": "Jeddah",
  "vehicle": {
    "plateNumber": "ABC-1234"
  },
  "driver": {
    "name": "Driver Name",
    "phoneNumber": "+966500000000"
  }
}`
};

export function validateJsonText(value: string | null | undefined, allowBlank = true): JsonValidationResult {
  const text = (value ?? '').trim();
  if (!text) {
    return allowBlank
      ? { valid: true, normalized: null, value: null }
      : { valid: false, message: 'JSON is required.' };
  }

  try {
    const parsed = JSON.parse(text) as unknown;
    return {
      valid: true,
      value: parsed,
      normalized: JSON.stringify(parsed, null, 2)
    };
  } catch (error) {
    return {
      valid: false,
      message: error instanceof Error ? error.message : 'Invalid JSON.'
    };
  }
}

export function normalizeJsonText(value: string | null | undefined, allowBlank = true): string | null {
  const result = validateJsonText(value, allowBlank);
  if (!result.valid) {
    throw new Error(result.message ?? 'Invalid JSON.');
  }
  return result.normalized ?? null;
}

export function prettyJson(value: string | null | undefined): string {
  const result = validateJsonText(value, true);
  return result.valid ? result.normalized ?? '' : value ?? '';
}
